<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="$t('data.withdraw_information_confirmation')"
    width="560px"
    class="diglog-card multi-withdraw-confirm-modal"
    :close-on-click-modal="false"
    @closed="handleDialogClosed"
  >
    <div class="header-line" />

    <div class="confirm-details">
      <div class="confirm-row">
        <span>{{ $t('data.cash_out_amount') }}</span>
        <strong>{{ confirmData.currency }} {{ confirmData.formatted_amount }}</strong>
      </div>
      <div class="confirm-row">
        <span>{{ $t('data.account') }}</span>
        <strong>{{ confirmData.account_label || '-' }}</strong>
      </div>
      <div class="confirm-row">
        <span>{{ $t('dashboard.fee') }}</span>
        <strong>{{ confirmData.arrival_currency }} {{ confirmData.formatted_fee }}</strong>
      </div>
      <div v-if="!hideUsdManualQuoteArrival" class="confirm-row confirm-row--arrival">
        <span>{{ $t('data.amount_received') }}</span>
        <div>
          <strong>{{ confirmData.arrival_currency }} {{ confirmData.arrival_amount }}</strong>
          <p v-if="showExchangeRate" class="exchange-rate">
            1.00 {{ confirmData.arrival_currency }} = {{ confirmData.exchange_rate }} {{ confirmData.currency }}
          </p>
        </div>
      </div>
    </div>

    <el-form
      v-if="$store.getters.isOpenMfa"
      ref="confirmForm"
      :model="confirmForm"
      :rules="rules"
      label-position="top"
      class="mfa-form"
    >
      <el-form-item :label="$t('system.mfa_verify_code')" prop="verification_code">
        <el-input
          v-model="confirmForm.verification_code"
          maxlength="6"
          placeholder="Enter your MFA verification code"
          autocomplete="off"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="info" class="btn-submit" :loading="submitting" @click="onClickSubmit">
        {{ $t('components.submit') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { multiMchExchangeWithdrawal } from '@/api/merchant-manage/merchant-manage'

export default {
  name: 'Multi_Mch_Withdraw_Confirm_Modal',
  data() {
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (/\s/.test(value)) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (!/^\d{6}$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      callback()
    }

    return {
      dialogVisible: false,
      submitting: false,
      confirmData: {},
      confirmForm: {
        verification_code: ''
      },
      rules: {
        verification_code: [
          { required: true, message: 'MFA Verification Code cannot be empty', trigger: 'blur' },
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    hideUsdManualQuoteArrival() {
      return this.$store.getters.isAllCountry &&
        this.confirmData.quotation_type === 1 &&
        this.confirmData.arrival_currency === 'USD'
    },
    showExchangeRate() {
      if (this.hideUsdManualQuoteArrival) {
        return false
      }
      return this.confirmData.exchange_rate &&
        this.confirmData.arrival_currency !== this.confirmData.currency
    }
  },
  methods: {
    changeModalStatus(value, data = {}) {
      this.dialogVisible = value
      this.confirmData = data
      this.confirmForm.verification_code = ''
    },
    onClickSubmit() {
      if (this.$store.getters.isOpenMfa) {
        this.$refs.confirmForm.validate(valid => {
          if (valid) {
            this.submitWithdraw()
          }
        })
        return
      }
      this.submitWithdraw()
    },
    submitWithdraw() {
      this.submitting = true
      const params = {
        amount: this.confirmData.amount,
        currency: this.confirmData.currency,
        quote_id: this.confirmData.quote_id || null,
        invoice_files: this.confirmData.invoice_files || [],
        mfa_code: this.confirmForm.verification_code,
        bank_no: this.confirmData.bank_no,
        timestamp: Date.now()
      }
      const aesKey = this.$commonFn.generateRandomString()
      const aesIV = this.$commonFn.generateRandomString()
      const encryptedParams = {
        key: this.$commonFn.rsaEncrypt(JSON.stringify({ key: aesKey, iv: aesIV })),
        param: this.$commonFn.cryptoJSAesEncrypt(JSON.stringify(params), aesKey, aesIV),
        sign: this.$commonFn.rsaSign(JSON.stringify(params))
      }

      multiMchExchangeWithdrawal(encryptedParams).then(res => {
        this.dialogVisible = false
        this.$emit('success', {
          amount: this.$commonFn.mathDivide(params.amount, 100),
          currency: params.currency
        })
      }).finally(() => {
        this.submitting = false
      })
    },
    handleDialogClosed() {
      this.confirmData = {}
      this.confirmForm.verification_code = ''
      this.$emit('closed')
      this.$nextTick(() => {
        if (this.$refs.confirmForm) {
          this.$refs.confirmForm.clearValidate()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.confirm-details {
  padding: 10px 4px 4px;
}

.confirm-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 24px;
  padding: 13px 0;
  color: #4b5567;
  border-bottom: 1px solid #ebeef5;

  strong {
    max-width: 330px;
    color: #14294f;
    font-weight: 500;
    text-align: right;
    word-break: break-all;
  }
}

.confirm-row--arrival {
  border-bottom: none;

  > div {
    text-align: right;
  }
}

.exchange-rate {
  margin: 5px 0 0;
  color: #98a1b4;
  font-size: 12px;
}

.mfa-form {
  margin-top: 16px;
}

.dialog-footer {
  text-align: center;
}

.btn-submit {
  width: 320px;
  height: 40px;
}
</style>
